import { getSuggestionsApi } from "@/apis/suggestion";
import { GetApiClient } from "@/utils/api-client";

export class SuggestionUsecase {
  static suggestions(apiClient: GetApiClient) {
    return getSuggestionsApi(apiClient);
  }
}
